import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Editor } from "primereact/editor";
import { Checkbox } from "primereact/checkbox";
import { IMassMailHistory } from "../massMailHistory/Table";

interface IProps {
  open: boolean;
  hideDialog: () => void;
  toast: any;
  existingMail?: IMassMailHistory | null;
}

export const EmailHistory = ({
  open,
  hideDialog,
  existingMail
}: IProps) => {

  const [body, setBody] = useState("");

  const header = () => <span>Email History</span>;

  
  useEffect(() => {
    if (!open) return;

   
    setBody("");

    if (existingMail?.email_Body) {
      setBody(existingMail.email_Body);
    }
  }, [open, existingMail]);

  const onHide = () => {
    hideDialog();
    setBody("");
  };

  return (
    <Dialog
      visible={open}
      style={{ width: "80vw" }}
      header={header}
      className="p-fluid"
      onHide={onHide}
      draggable={false}
    >

      <div className="grid">

           <div className="col-12 md:col-6 flex align-items-end">
          <Checkbox
            checked={existingMail?.to_Self === true}
            disabled
          />
          <label style={{ marginLeft: "8px" }}>To Self</label>
        </div>
       
        <div className="col-12">
          <label style={{ fontWeight: 600 }}>Subject</label>
          <div className="p-2 border-1 border-round border-300">
            {existingMail?.email_Subject || "-"}
          </div>
        </div>

       
        <div className="col-12 md:col-6">
          <label style={{ fontWeight: 600 }}>CC</label>
          <div className="p-2 border-1 border-round border-300">
            {existingMail?.email_CC || "-"}
          </div>
        </div>

        <div className="col-12">
          <label>Email Body</label>
          <Editor
            value={body}
            readOnly
            style={{ height: "350px" }}
          />
        </div>

      </div>

    </Dialog>
  );
};
